import { render, staticRenderFns } from "./index.vue?vue&type=template&id=496c8075&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c8075",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496c8075')) {
      api.createRecord('496c8075', component.options)
    } else {
      api.reload('496c8075', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=496c8075&scoped=true", function () {
      api.rerender('496c8075', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsManage/thirdSku/index.vue"
export default component.exports